// extracted by mini-css-extract-plugin
export var csatScore = "_jf-5";
export var header = "_jf-1";
export var panelWrapper = "_jf-2";
export var postPreview = "_jf-3";
export var rightContent = "_jf-0";
export var wrappingText = "_jf-4";